import { render, staticRenderFns } from "./SideBarApp.vue?vue&type=template&id=58e007db&scoped=true&"
import script from "./SideBarApp.vue?vue&type=script&lang=js&"
export * from "./SideBarApp.vue?vue&type=script&lang=js&"
import style0 from "./SideBarApp.vue?vue&type=style&index=0&id=58e007db&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e007db",
  null
  
)

export default component.exports